
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { DataTableHeaders } from '@/types';
    import Impferinnerung from '@/types/Impferinnerung';

    @Component
    export default class ErinnerungenDatatable extends Vue {
        @Prop({ default: () => [] }) public items!: Impferinnerung[];
        @Prop({ default: () => false }) public singleSelect!: boolean;
        @Prop({ default: () => false }) public loading!: boolean;
        @PropSync('selected') public selectedSynced!: Impferinnerung[];

        public get headers(): DataTableHeaders<Impferinnerung> {
            return [
                { text: 'gesendet am', value: 'erinnerung_gesendet', width: 150 },
                { text: 'Impfung', value: 'impfung' },
                { text: 'Nächste Impfung', value: 'naechstesimpfdatum', width: 150 },
            ];
        }
    }
